export default "__VITE_ASSET__Dsnp5yNf__"